export default "/images/66ba5109c5d38a021d32733185b4210f.avif";